import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4bf0047a")

_pushScopeId("data-v-4bf0047a")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "p-grid" }
const _hoisted_3 = { class: "p-col-12" }
const _hoisted_4 = { class: "p-text-truncate p-pb-1 p-pt-4" }
const _hoisted_5 = {
  key: 0,
  class: "p-error p-ml-2"
}
const _hoisted_6 = {
  key: 1,
  class: "p-error p-ml-2"
}
const _hoisted_7 = { class: "p-d-flex p-ai-center" }
const _hoisted_8 = {
  key: 0,
  class: "p-pl-2 p-error"
}
const _hoisted_9 = {
  key: 1,
  class: "p-pl-2 p-error"
}
const _hoisted_10 = {
  key: 2,
  class: "p-pl-2"
}
const _hoisted_11 = { class: "p-d-flex p-jc-between" }
const _hoisted_12 = { class: "p-d-flex" }
const _hoisted_13 = { class: "p-ml-2 p-mb-4 p-mt-4" }
const _hoisted_14 = { class: "" }
const _hoisted_15 = { class: "" }
const _hoisted_16 = { class: "" }
const _hoisted_17 = { class: "" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_DataType = _resolveComponent("DataType")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_TabMenu = _resolveComponent("TabMenu")!
  const _component_ExperimentTag = _resolveComponent("ExperimentTag")!
  const _component_KpiTag = _resolveComponent("KpiTag")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.listRowData.length > 0)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("span", null, _toDisplayString(_ctx.listHeader.length) + " " + _toDisplayString(_ctx.$t("upload.datasource.colums")) + " _ " + _toDisplayString(_ctx.listRowData.length) + " / " + _toDisplayString(_ctx.totalRow) + " " + _toDisplayString(_ctx.$t("upload.datasource.row")), 1),
              (_ctx.notExistColumns.length > 0)
                ? _withDirectives((_openBlock(), _createBlock("span", _hoisted_5, [
                    _createTextVNode("*" + _toDisplayString(_ctx.$t("upload.datasource.header.column.notExist", {
                columns: _ctx.notExistColumns.toString(),
              })), 1)
                  ], 512)), [
                    [
                      _directive_tooltip,
                      
              _ctx.$t('upload.datasource.header.column.notExist', {
                columns: _ctx.notExistColumns.toString(),
              })
            ,
                      void 0,
                      { top: true }
                    ]
                  ])
                : _createCommentVNode("", true),
              (_ctx.hasErrorHeader)
                ? (_openBlock(), _createBlock("span", _hoisted_6, " *" + _toDisplayString(_ctx.$t("datasource.error.invalid_headers")), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createVNode(_component_DataTable, {
          scrollable: true,
          scrollHeight: "138px",
          value: _ctx.listRowData,
          showGridlines: "",
          class: "p-datatable-sm",
          loading: _ctx.loading
        }, {
          default: _withId(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listHeader, (col, key) => {
              return (_openBlock(), _createBlock(_component_Column, {
                key: key,
                field: col.field,
                style: {"min-width":"200px"}
              }, {
                header: _withId(() => [
                  _createVNode("div", _hoisted_7, [
                    _createVNode(_component_DataType, {
                      dataType: col.code.type
                    }, null, 8, ["dataType"]),
                    (_ctx.checkIfStringHasSpecialChar(col.header))
                      ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_8, [
                          _createTextVNode(_toDisplayString(col.header), 1)
                        ], 512)), [
                          [_directive_tooltip, _ctx.$t('upload.datasource.header.column.error')]
                        ])
                      : (_ctx.checkIfDuplicatedName(col.header))
                        ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_9, [
                            _createTextVNode(_toDisplayString(col.header), 1)
                          ], 512)), [
                            [_directive_tooltip, _ctx.$t('upload.datasource.header.column.duplicate')]
                          ])
                        : (_openBlock(), _createBlock("div", _hoisted_10, _toDisplayString(col.header), 1))
                  ])
                ]),
                _: 2
              }, 1032, ["field"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["value", "loading"]),
        (_ctx.workbook)
          ? (_openBlock(), _createBlock(_component_TabMenu, {
              key: 0,
              model: _ctx.worksheetNames,
              onTabChange: _ctx.onTabChange
            }, null, 8, ["model", "onTabChange"]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_11, [
          _createVNode("div", _hoisted_12, [
            _createVNode("h4", _hoisted_13, _toDisplayString(_ctx.$t("automl.upload.prediction.modelsList")), 1)
          ])
        ]),
        _createVNode(_component_DataTable, {
          removableSort: "",
          responsiveLayout: "scroll",
          "sort-field": _ctx.sortField,
          "sort-order": _ctx.sortOrder,
          value: _ctx.leaderBoard,
          onRowSelect: _ctx.onRowSelect,
          selectionMode: "single",
          selection: _ctx.selectedModel,
          "onUpdate:selection": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedModel = $event)),
          scrollable: true,
          scrollHeight: "190px",
          showGridlines: ""
        }, {
          default: _withId(() => [
            _createVNode(_component_Column, {
              field: "name",
              header: _ctx.$t('automl.evaluation.leaderBoard.headers.modelName'),
              key: "id",
              sortable: true
            }, {
              body: _withId(({ data }) => [
                _createVNode("div", _hoisted_14, [
                  _createVNode("span", null, _toDisplayString(data.name), 1)
                ])
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_Column, {
              field: "modelType",
              header: _ctx.$t('automl.evaluation.leaderBoard.headers.modelType'),
              key: "id",
              sortable: true
            }, {
              body: _withId(({ data }) => [
                _createVNode("div", _hoisted_15, [
                  _createVNode("span", null, _toDisplayString(data.modelType), 1),
                  (data.isExplainable)
                    ? (_openBlock(), _createBlock(_component_ExperimentTag, {
                        key: 0,
                        name: 'EXPLAINABLE',
                        class: "p-ml-2"
                      }))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_Column, {
              field: "valScore",
              header: _ctx.$t('automl.evaluation.leaderBoard.headers.validationScore'),
              key: "id",
              sortable: true
            }, {
              body: _withId(({ data }) => [
                _createVNode("div", _hoisted_16, [
                  _createVNode(_component_KpiTag, {
                    name: data.primaryMetric,
                    value: data.valScore,
                    best: data.valScore === _ctx.bestValidationScore,
                    percentage: data.percentage
                  }, null, 8, ["name", "value", "best", "percentage"])
                ])
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_Column, {
              field: "testScore",
              header: _ctx.$t('automl.evaluation.leaderBoard.headers.testScore'),
              key: "id",
              sortable: true
            }, {
              body: _withId(({ data }) => [
                _createVNode("div", _hoisted_17, [
                  _createVNode(_component_KpiTag, {
                    name: data.primaryMetric,
                    value: data.testScore,
                    best: data.testScore === _ctx.bestTestScore,
                    percentage: data.percentage
                  }, null, 8, ["name", "value", "best", "percentage"])
                ])
              ]),
              _: 1
            }, 8, ["header"])
          ]),
          _: 1
        }, 8, ["sort-field", "sort-order", "value", "onRowSelect", "selection"])
      ]))
    : _createCommentVNode("", true)
})